import React from 'react';
import PropTypes from 'prop-types';
import BikeIcon from 'assets/icons/BikeIcon';
import CarIcon from 'assets/icons/CarIcon';
import ParkingTicketIcon from 'assets/icons/ParkingTicketIcon';
import TaxiIcon from 'assets/icons/TaxiIcon';
import categoryHelper from 'helpers/category';
import dateUtils from 'helpers/dateUtils';
import styled from 'styled-components';

const StyledIcon = styled.div`
    height: 36px;
    width: 36px;
    margin-right: 10px;
`;

const StyledWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledTitle = styled.div`
    font-size: 14px;
    line-height: 1.4;
    font-weight: 600;
`;

const StyledSubtitle = styled.div`
    font-size: 12px;
    line-height: 1.4;
    font-style: italic;
`;

const Header = (props) => {
    const {
        icon,
        subTitle,
        title,
    } = props;

    return (
        <StyledWrapper>
            <StyledIcon>
                { icon &&
                    icon
                }
            </StyledIcon>

            <StyledContent>
                <StyledTitle>{ title }</StyledTitle>

                { subTitle &&
                    <StyledSubtitle>{ subTitle }</StyledSubtitle>
                }
            </StyledContent>
        </StyledWrapper>
    );
};

Header.propTypes = {
    icon: PropTypes.node,
    subTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
};

const BookingReservationHeader = (props) => {
    const {
        booking,
        product,
    } = props;

    const {
        destination_departure_date: departureDateString,
        destination_arrival_date: arrivalDateString,
    } = booking;

    const {
        category_id: categoryId,
    } = product;

    let icon = null;
    let title = product.title;

    const arrivalDate = dateUtils.stringToDate(arrivalDateString);
    const departureDate = dateUtils.stringToDate(departureDateString);

    let dateString = dateUtils.combineDatesToString(arrivalDate, departureDate);
    let subTitle = dateString;

    switch (categoryId) {
        case categoryHelper.getCategoryHubId():
        case categoryHelper.getCategoryParkingId():
            icon = <CarIcon />;
            break;
        case categoryHelper.getCategoryTaxiId():
            icon = <TaxiIcon />;
            break;
        case categoryHelper.getCategoryBikeId():
            icon = <BikeIcon />;
            break;
        case categoryHelper.getCategoryTransferId():
        default:
            icon = <ParkingTicketIcon />;
    }

    return <Header
        icon={ icon }
        title={ title }
        subTitle={ subTitle }
    />;
};

BookingReservationHeader.propTypes = {
    booking: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
};

export default BookingReservationHeader;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookingReservations/BookingReservationHeader.js